// savings-balance.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  CustomValidators,
  MustMatchRadioOptionValidatorConfig,
} from '@finxone-platform/shared/sys-config-types';

export class MustMatchRadioOptionValidator {
  createSyncFromConfig(config: MustMatchRadioOptionValidatorConfig): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Skip validation if control is empty and configured to do so
      if (config.skipValidationOnEmpty && !control.value) {
        return null;
      }

      // Check if an object
      if (typeof control.value !== 'object' && control.value === null) {
        return { invalidOption: 'Invalid option selected, are options an object?' };
      }

      const validOptions = config.selectedOptions ?? [];

      if (!validOptions.length) {
        return null; // No valid options to match against
      }

      const optionValue = control.value;

      if (validOptions.includes(optionValue)) {
        return null; // Valid option selected
      } else {
        const errors: ValidationErrors = {};
        errors['invalidOption'] = config.defaultErrorMessage || 'Invalid option selected';
        return errors;
      }
    };
  }
}

// validation-config.json (example configuration)
export const MUST_MATCH_RADIO_OPTION_VALIDATION_CONFIG: MustMatchRadioOptionValidatorConfig = {
  type: CustomValidators.MUST_MATCH_RADIO_OPTION_VALIDATOR,
  selectedOptions: ['option1', 'option2'],
  defaultErrorMessage: 'Please select a valid option',
  skipValidationOnEmpty: false,
};
